"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./../utils");
exports.inventoryMapper = function (inventoryDto) {
    return {
        _id: inventoryDto.id,
        externalId: inventoryDto.externalId,
        trackQuantity: inventoryDto.trackQuantity,
        variants: inventoryDto.variants,
        _updatedDate: new Date(inventoryDto.lastUpdated),
    };
};
exports.inventoryDbDriverMapper = function (inventoryDto) {
    var _a = exports.inventoryMapper(inventoryDto), _ = _a._updatedDate, rest = __rest(_a, ["_updatedDate"]);
    return __assign(__assign({}, rest), { _updatedDate: utils_1.createWixCodeDateTimeObject.fromISODate(inventoryDto.lastUpdated) });
};
//# sourceMappingURL=inventory.mapper.js.map